import { HomeFunnelState } from 'scenes/home/types';
import { WirePayment } from 'scenes/common/analytics/types';
import { getPaymentFrequency, getPaymentMethod } from 'scenes/home/selectors';

export const toWirePayment = (state: HomeFunnelState): WirePayment => ({
  method: getPaymentMethod(state),
  terms: getPaymentFrequency(state),
});
